import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Injectable} from '@angular/core';


interface MathJaxConfig {
  source: string;
  id: string;
}

declare global {
  interface Window {
    MathJax: {
      typesetPromise: () => void;
      startup: {
        promise: Promise<any>;
      };
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class MathService {

  private readonly signal: Subject<boolean>;
  private mathJax: MathJaxConfig = {
    source: 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js',
    id: 'MathJax-script'
  };

  constructor() {
    this.signal = new ReplaySubject<boolean>();

    MathService.configureMathJax();

    void this.registerMathJaxAsync(this.mathJax)
      .then(() => this.signal.next(true));
  }

  private async registerMathJaxAsync(config: MathJaxConfig): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const script: HTMLScriptElement = document.createElement('script');
      script.type = 'text/javascript';
      script.id = config.id;
      script.src = config.source;
      script.crossOrigin = 'anonymous';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = error => reject(error);
      document.head.appendChild(script);
    });
  }

  private static configureMathJax(): void {
    const script: HTMLScriptElement = document.createElement('script');
    script.text = `window.MathJax = {
        tex: {
          inlineMath: [ ["$","$"] ],
          displayMath: [ ["$$","$$"] ],
          processEscapes: true
        }
      };`;
    document.head.appendChild(script);
  }

  ready(): Observable<boolean> {
    return this.signal;
  }

  renderPageMath() {
    void window.MathJax.startup.promise.then(() => {
      window.MathJax.typesetPromise();
    });
  }
}
